import { mapImageFields } from '@/adapters/common'
import { IInfoCard } from '@/interfaces/common'

export function mapInfoCardFields(item: Directus.InfoCard): IInfoCard {
  return {
    image: mapImageFields(item.image),
    ...item.translations[0],
  }
}
